import { useOutletContext } from "react-router-dom";
import { useState, useEffect } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

import { translations } from './../../../i18/translations.js';
import './BiokemSearch.css';
import Search from './../../../util/Search.js';
import Pager from './../../../util/Pager.js';

const BiokemSearch = () => {

    const API_URL = process.env.REACT_APP_SERVICE_API_URL;
    const RESOURCES_DIR = process.env.REACT_APP_RESOURCES_DIR;

    const {lang} = useOutletContext();
    const [query, setQuery] = useState('');
    const [results, setResults] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [pageIndex, setPageIndex] = useState(0);
    const [loading, setLoading] = useState(false);

    const toggleModal = () => {
        setModalOpen(!modalOpen);
        if (modalOpen) {
            setQuery('');
            setPageIndex(0);
        }
    };

    useEffect(() => {
        fetchResults(query, pageIndex);
    }, [pageIndex, query]);

    const fetchResults = async (searchQuery, page = 0) => {
        if (!searchQuery.trim()) {
            return;
        }
        setModalOpen(true);
        setLoading(true);
        const payload = {
            filter: {
                pageSize: 4,
                pageIndex: page,
                query: searchQuery
            }
        };
        try {
            const response = await fetch(`${API_URL}/common/biokem_search.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            setResults(data);
            setPageIndex(page);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching search results:', error);
    }
    };

    const handleSearch = (query) => {
        setQuery(query);
        setPageIndex(0);
    };

    return (
            <div>
            
                <Search placeholder={translations[lang].search_biokem} handleSearch={handleSearch} />            
            
                <Modal isOpen={modalOpen} toggle={toggleModal} size="lg" backdrop={true}>
                    <ModalHeader toggle={toggleModal}>
                        {translations[lang].search}: '{query}' 
                        {loading ? (<div className='loading px24 float-end' />) : ', ' + translations[lang].results + (results ? results.template : '')}
                    </ModalHeader>
                    <ModalBody className='biokem-modal-body mbkegy-content'>
                        {results && results.data.length > 0 ? (
                            <div>
                
                                {results.data.map((item) => (
                                                            <div className="card mb-3">
                                                                <div className="row g-0">
                                                                    <div className="col-auto">
                                                                        <img src={`${RESOURCES_DIR}/biokem/${item.image}`} alt={item.title} className="img-fluid" style={{width: '100px'}} />
                                                                    </div>
                                                                    <div className="col-auto">
                                                                        <div className="card-body biokem-card-body">
                                                                            <h5 className="card-title">{item.title}</h5>
                                                                            <p className="card-text">
                                                                                {item.sample}...
                                                                            </p>
                                                                            <p className="card-text">
                                                                                <a href={`${RESOURCES_DIR}/biokem/${item.year_index.substring(0, 4)}/${item.year_index}.pdf`} className="content-view-link" target="newWin">{item.year_index}.pdf</a>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>


                                                                    ))}
                
                                <Pager template='' pager={results.pagerButtonIndexes} handlePageChange={setPageIndex} />
                
                            </div>
                                    ) : (
                            <p>{loading ? translations[lang].searching + '...' : translations[lang].no_result + '.'}</p>
                                    )}
                    </ModalBody>
                </Modal>
            </div>
            );
};

export default BiokemSearch;
